import Vue from 'vue'
import Router from 'vue-router'
import VueCookie from 'vue-cookie';

import Main from '@/components/main/Main'
import Dashboard from '@/components/dashboard/Dashboard'
import Selection from '@/components/main/Selection'
import ServiceObjects from '@/components/service-objects/ServiceObjectsOverview'
import ServiceContracts from '@/components/service-contracts/ServiceContractsOverview'
import ServiceCalls from '@/components/service-calls/ServiceCallsOverview'
import ServiceObjectDetail from '@/components/service-objects/ServiceObjectDetail'
import ServiceContractDetail from '@/components/service-contracts/ServiceContractDetail'
import ServiceCallDetail from '@/components/service-calls/ServiceCallDetail'
import CompanyOverview from '@/components/admin/CompanyOverview'
import SalesGroupOverview from '@/components/admin/SalesGroupOverview'
import SalesGroupDetail from '@/components/admin/SalesGroupDetail'
import UserDetail from '@/components/admin/UserDetail'
import InvoicesOverview from '@/components/invoices/InvoicesOverview'

import Login from '@/components/login/Login'
import { user } from './../user.js';

Vue.use(Router)
Vue.use(VueCookie)

/**
 * Hardcoded rollen (frontend)
 * 1 = Service User
 * 2 = Super User
 * 3 = Admin
 * 4 = Facturen User
 */

const ROLE = {
    SERVICE_USER_ROLE_ID: 1,
    SUPER_USER_ROLE_ID: 2,
    ADMIN_ROLE_ID: 3,
    INVOICE_ROLE_ID: 4
}

const http = () => Vue.prototype.$axios;

async function fetchUserRoleId () {
    try {
        const { data } = await http().get('/selection')
        if (typeof data?.roleId === 'number')
            return [data.roleId];

        return [];
    } catch (e) {
        console.log(e);
        return []
    }
}

function derivePermissions (roleIds) {
    const has = id => roleIds.includes(id)
    const isSuperOrAdmin = has(ROLE.SUPER_USER_ROLE_ID) || has(ROLE.ADMIN_ROLE_ID)

    return {
        canService: isSuperOrAdmin || has(ROLE.SERVICE_USER_ROLE_ID),
        canInvoices: isSuperOrAdmin || has(ROLE.INVOICE_ROLE_ID),
        isSuperOrAdmin
    }
}

const router = new Router({
  mode: 'hash',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [
      { path: '/', redirect: '/main/selection'},
      { name: 'login', path: '/login', component: Login },
      {
        name: 'main',
        path: '/main',
        component: Main,
        children: [
            { path: 'dashboard', name: 'dashboard', component: Dashboard },
            { path: 'selection', name: 'selection', component: Selection },

            { path: 'service-objects', name: 'service-objects', component: ServiceObjects },
            { path: 'service-objects/:id', name: 'service-object', component: ServiceObjectDetail },

            { path: 'service-contracts', component: ServiceContracts },
            { path: 'service-contracts/:id', name: 'service-contract', component: ServiceContractDetail },

            { path: 'service-calls', component: ServiceCalls},
            { path: 'service-calls/:id',  name: 'service-call',  component: ServiceCallDetail },

            { path: 'invoices',  name: 'invoices',  component: InvoicesOverview },

            { name: 'admin',  path: '/admin',  component: CompanyOverview },

            { name: 'sales-group-overview',  path: '/sales-group-overview/:id',  component: SalesGroupOverview },
            { name: 'sales-group-detail',  path: '/sales-group-detail/:companyId/:salesGroupId', component: SalesGroupDetail },
            { name: 'user-detail',  path: '/user-detail/:companyId/:salesGroupId/:loginKey',  component: UserDetail }
        ]
      }
  ]
})

router.beforeEach(async (to, from, next) => {
  // If the user is not authenticated
  if (!user.isAuthenticated) {
    if (to.name !== 'login') return next({ path: '/login' });
    return next();
  }

  if (to.path.startsWith('/main')) {
      const companyId = Vue.cookie.get('companyId');
      const allowWithoutCompanySelection = ['selection', 'dashboard'].includes(to.name);

      if ((!companyId || companyId === '') && !allowWithoutCompanySelection) {
          return next({ path: '/main/selection' });
      }
  }

  if (to.name === 'login') return next({ path: '/main/selection' });

  const roleIds = await fetchUserRoleId();
  const permissions = derivePermissions(roleIds);

  const name = to.name;

  if (name === 'invoices' && !permissions.canInvoices) {
      return next({ path: '/main/selection' });
  }

  const isServiceRoute = ['service-objects','service-contracts','service-calls','service-object','service-contract','service-call'].includes(name)
  if (isServiceRoute && !permissions.canService) {
      return next({ path: '/main/selection' });
  }

  const isAdminRoute = ['admin','sales-group-overview','sales-group-detail','user-detail'].includes(name)
  if (isAdminRoute && !permissions.isSuperOrAdmin) {
      return next({ path: '/main/selection' });
  }

  next();
});

export default router;
